import React from "react";
import "../Footer/Footer.css";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="lawyer-footer">
      <div className="footer-container">
        {/* Top Section */}
        <div className="footer-top">
          <div className="footer-about">
            <div className="footer-logo">
              <Link to="/">
                <img
                  src="/logo.webp"
                  alt="Law Firm Logo"
                  className="logo-img"
                />
              </Link>
            </div>
            <p className="about-text">
              Lawyer Firm is a premier law firm specializing in corporate law,
              litigation, and family law. With over 10 years of experience to
              deliver legal services.
            </p>
          </div>

          <div className="footer-links">
            <h4 className="links-title">Quick Links</h4>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/aboutus">About Us</Link>
              </li>
              <li>
                <Link to="/case-studies">Case Study</Link>
              </li>
              <li>
                <Link to="/practicearea">Practice Area</Link>
              </li>
              <li>
                <Link to="/contactus">Contact Us</Link>
              </li>
            </ul>
          </div>

          <div className="footer-case-studies">
            <h4 className="links-title">Case Studies</h4>
            <ul>
              <li>
                <Link to="/case-studies/1">Family Violence </Link>
              </li>
              <li>
                <Link to="/case-studies/2">Million Air Its Wings</Link>
              </li>
              <li>
                <Link to="/case-studies/3">Child Custody </Link>
              </li>
              <li>
                <Link to="/case-studies/4">Million Air Expansion</Link>
              </li>
              <li>
                <Link to="/case-studies/5">Corporate Fraud </Link>
              </li>
            </ul>
          </div>

          <div className="footer-newsletter">
            <h4 className="links-title">Stay Updated</h4>
            <p className="newsletter-text">
              Subscribe to our newsletter for legal insights and firm updates.
            </p>
            <form className="newsletter-form">
              <input
                type="email"
                placeholder="Your Email Address"
                required
                className="newsletter-input"
              />
              <button type="submit" className="newsletter-btn">
                Subscribe
              </button>
            </form>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="footer-bottom">
          <div className="copyright">
            &copy; {new Date().getFullYear()} Lawyer Firm. All Rights Reserved.
            Powered by{" "}
            <a
              href="https://infogainsoft.com"
              className="link-ff"
              target="_blank"
              rel="noopener noreferrer"
            >
              Infogainsoft
            </a>
          </div>
          <div className="social-icons">
            <a href="#" aria-label="Facebook">
              <FaFacebookF />
            </a>
            <a href="#" aria-label="Twitter">
              <FaTwitter />
            </a>
            <a href="#" aria-label="LinkedIn">
              <FaLinkedinIn />
            </a>
            <a href="#" aria-label="Instagram">
              <FaInstagram />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
